import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App'

// Global Components
import './global-components'

// 3rd party plugins
import '@/plugins'
import '@/plugins/x5gmaps'
import '@/plugins/portal-vue'
import '@/plugins/toastification'
import '@/plugins/virtual-scroller'
import '@/filters/filters'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
require('@core/scss/vue/libs/vue-select.scss')

Vue.config.productionTip = false

import PermissionHelper from './helpers/permissionHelper.js'
const plugin = {
  install () {
    Vue.PermissionHelper = PermissionHelper
    Vue.prototype.$PermissionHelper = PermissionHelper
  }
} 
Vue.use(plugin)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
